<section class="custom-dialog-content">
    <div class="headline">
        <img src="./assets/contact/logo.svg" alt="logo">
        <h1> Edit contact</h1>
        <h3>Tasks are better with a team!</h3>
        <div class="blueline"></div>
    </div>

    <div class="add_contacts_content">
        <div class="close_btn" >
            <img (click)="closeDialog()" src="./assets/contact/Close.svg" alt="close">
        </div>
        
        <div class="form_content">
            <div class="avatar" [ngStyle]="{'background-color': contact.color}"><h2>{{contact.firstname.charAt(0)}}{{contact.lastname.charAt(0)}}</h2></div>
        <form (ngSubmit)="onEditContact(contactForm)" #contactForm="ngForm">

            <label class="input_content">
                <input type="text" [(ngModel)]="contact.fullname" name="fullname"
                    [placeholder]="fullname.invalid && fullname.touched ? 'Please enter your name' : 'Name'" value="{{editedContact.firstname}}"
                    #fullname="ngModel" [ngClass]="{'input-error': fullname.invalid && fullname.touched}" required minlength="4">
                <img src="./assets/contact/person.svg" alt="Person">
            </label>
            @if (fullname.invalid && fullname.touched) {
                <p class="error-color">please enter name and last name</p>
            }
            <label class="input_content">
                <input type="email" [(ngModel)]="contact.email" name="email"
                    [placeholder]="email.invalid && email.touched ? 'Please enter a valid email' : 'Email'"
                    #email="ngModel" [ngClass]="{'input-error': email.invalid && email.touched}" required pattern="[a-z0-9._%+\-]+@[a-z0-9\-]+\.[a-z]{2,}$" minlength="4">
                <img src="./assets/contact/mail.svg" alt="mail">
            </label>
            @if (email.invalid && email.touched) {
                <p class="error-color">please enter a valid email address</p>
            } 
            <label class="input_content">
                <input type="text" [(ngModel)]="contact.phone" name="phone"
                    [placeholder]="phone.invalid && phone.touched ? editedContact.phone : editedContact.phone"
                    #phone="ngModel" [ngClass]="{'input-error': phone.invalid && phone.touched }" required pattern="\+?[0-9\s\-\(\)]{10,}" minlength="7">
                <img src="./assets/contact/call.svg" alt="phone">
            </label>
            @if (phone.invalid && phone.touched) {
                <p class="error-color">please enter a valid phone number of 8 digits</p>
            } 
            <div class="btn_container">
                <button class="cancel_btn" (click)="closeDialog()">
                    Cancel
                    <img src="./assets/contact/Close.svg" alt="cancel" >
                </button>

                <button class="create_btn" type="submit" [disabled]="!contactForm.valid" (click)="closeDialog()">
                    Edit contact
                    <img src="./assets/contact/check.svg" alt="Create">
                </button>
            </div>

        </form>
    </div>
    </div>
</section>
